# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/
window.NestedFormEvents::insertFields = (content, assoc, link) ->
  $tr = $(link).closest("tr")
  $(content).insertBefore $tr

documentRecalc = ->
  list_pcs = $("[id$=_pcs]:visible")
  list_price = $("[id$=_price]:visible")
  i = 0
  total = 0
  while i < list_pcs.length
    total = total + list_pcs.eq(i).val() * list_price.eq(i).val()
    i++
  $("input#document_total").val total.toFixed(2)

setWarehouse = ->
  list = $("[id$=_product_name]:visible")
  i = 0
  id = $("#document_warehouse_id").val()
  while i < list.length
    list.eq(i).attr("data-autocomplete", "/document_items/autocomplete_product_name?set=0&warehouse_id=" + id)
    list.eq(i).attr("data-id-element", "#" + list.eq(i).next("input[type=hidden]").attr("id"))
    i++

$(document).on 'turbolinks:load', ->
  $("#document_document_date").datetimepicker({timeFormat: 'HH:mm', language: 'cs-CZ', dateFormat: "yy-mm-dd"})

  $("#cislo").focus()
  $("cislo_pickup").focus()

  $("input.calc").keyup ->
    fix_input($(this))
    documentRecalc()

  $("input.fixinput").keyup ->
    fix_input($(this))

  $("#document_warehouse_id").bind "change", (event, data) ->
    setWarehouse()

  if $("#document_warehouse_id").val() != undefined
    setWarehouse()

  $(document).on "nested:fieldAdded", (event) ->
    field = event.field
    calcField = field.find(".calc")
    calcField.keyup ->
      fix_input($(this))
      documentRecalc()
    $("[id$=_product_name]:visible[id^=document]:last").focus()
    setWarehouse()

  $(document).on "nested:fieldRemoved", (event) ->
    documentRecalc()

  # po výběru produktu z našeptávače doplň SKU do daného řádku
  $(document).on 'railsAutocomplete.select', '[id^=document_document_items][id$=_product_name]', (event, ui) ->
    $(this).closest("tr").find(".product-sku").val(if ui.item then ui.item.plu else '')

  $("#document_warehouse_id").change ->
    $.get "/products.json?warehouse_id=" + $(this).val(), (data, status, xhr) ->
      data = eval(data)
      $("input#document_document_items_attributes_0_product").val data.name

  $('#document_document_items_attributes_0_product').autocomplete
    source: $('#document_document_items_attributes_0_product').data('autocomplete-source')

  setWarehouse()

  fix_input = (t) ->
    a = t.val()
    a = a.replace(/,/g, '.')
    a = a.replace(/\+/g, '1')
    a = a.replace(/ě/g, '2')
    a = a.replace(/š/g, '3')
    a = a.replace(/č/g, '4')
    a = a.replace(/ř/g, '5')
    a = a.replace(/ž/g, '6')
    a = a.replace(/ý/g, '7')
    a = a.replace(/á/g, '8')
    a = a.replace(/í/g, '9')
    a = a.replace(/é|o/g, '0')
    a = a.replace(/\ |a|b|c|d|e|f|g|h|i|j|k|l|m|n|p|q|r|s|t|u|v|w|x|y|z/g, '')
    t.val a
    return

  $('#cislo_selectize').selectize
    persist: false
    maxItems: 1
    valueField: 'package'
    labelField: 'label'
    options: []
    create: (input)->
      package:input
      label: input,
      order:
        del_name: '?'
        del_surname: '?'

    searchField: [
      'package'
    ]

    render:
      item: (item, escape) ->
        '<div>' + '<strong class="package">' + escape(item.package) + '</strong>' + ' | <em class="info">' + escape(item.label) + '</em></div>'
      option: (item, escape) ->
        label = item.package
        caption = '<div class="order-title">' + escape(item.label) + '</div>'
        caption += (if item.order.del_name then '<div>' + escape(item.order.del_name) + ' ' + escape(item.order.del_surname) + '</div>' else '')
        caption += '<div>'
        caption += (if item.order.del_town then escape(item.order.del_town) else escape(item.order.town) ) + ', '
        caption += (if item.order.del_zip then escape(item.order.del_zip) else escape(item.order.zip) )

        caption += '<div class="dates"> Datum odeslání: <em>' + (if item.detail.date_sent then escape((new Date(Date.parse(item.detail.date_sent))).toLocaleDateString('cs')) else '?' ) + '</em> | Datum zpracování: <em>' + (if item.detail.date_prepare then escape((new Date(Date.parse(item.detail.date_prepare))).toLocaleDateString('cs')) else '?' )+'</em></div>'
        caption+= '<div>' + '<div class="package"><strong>' + escape(item.package) + '</strong></div>' + '<div class="caption">' + caption + '</div>'
        caption += '</div>'
        caption
    score: (search) ->
      score = this.getScoreFunction(search)
      (item)->
        Date.parse(item.detail.date_prepare)
#        score(item) * (1 + Math.min(item.watchers / 100, 1));

    load: (query, callback) ->
      console.log(query)
      if !query.length
        return callback()
      $.ajax
        url: '/documents/packages_to_return.json?q=' + encodeURIComponent(query)
        type: 'GET'
        error: ->
          callback()
          return
        success: (res) ->
          callback res.slice(0, 15)
          return
      return


